import OutOfOfficeModal from './OutOfOfficeModal'

export default OutOfOfficeModal
